let pageEntry;
export function getPageEntry() {
    pageEntry !== null && pageEntry !== void 0 ? pageEntry : (pageEntry = document.querySelector(".daily-bible-reading"));
    return pageEntry;
}
